export default __webpack_public_path__ + "static/media/single_fold.7353b018.jpg";